// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"e275d697","279":"d96860c4","315":"f70e7984","453":"c2b2afdb"}[chunkId] + ".chunk.js";
};